import React, { useEffect, useRef } from 'react';
import { playBuzzer } from './sounds/buzzer';
import { useScoreboard } from './context/ScoreboardContext';
import { getWarningColors } from './utils/colorUtils';
import { foulState } from '@rhs/core';

const TeamFoulsCounter = ({ fouls, onFoulChange, isLiveView = false, isWarningFoul = false }) => {
  const { backgroundColor } = useScoreboard();
  const isWarning = isWarningFoul || foulState(fouls).warning;
  const prevFoulsRef = useRef(fouls);

  // Get warning colors based on brand color using utility function
  const warningColors = getWarningColors(backgroundColor);

  useEffect(() => {
    // Play buzzer on the 10th foul and every 5th foul after that (foulState.buzzer),
    // but only when the count actually increased.
    if (fouls > prevFoulsRef.current && foulState(fouls).buzzer) {
      playBuzzer();
    }
    prevFoulsRef.current = fouls;
  }, [fouls]);

  return (
    <div className="flex items-center justify-center gap-[2vh]">
    {!isLiveView && (
    <button
      onClick={() => onFoulChange(Math.max(0, fouls - 1))}
      className="w-[8vh] h-[8vh] bg-amber-500 text-black text-[4vh] font-bold rounded-lg hover:bg-amber-600"
    >
      -
    </button>
    )}
    <div className={`${isWarning ? (isLiveView ? 'bg-transparent' : warningColors.backgroundColor) : isLiveView ? 'bg-transparent' : 'bg-white'} rounded-lg ${isLiveView ? 'w-full' : 'w-[12vh] p-[1vh]'}  text-center relative flex items-center justify-center`}>
      <div className={`${isWarning && !isLiveView ? 'box-content border-[0.5vh] border-white absolute inset-[0vh] rounded-md' : ''}`}></div>
      <span className={`${isLiveView ? 'text-[9vh] font-chivo leading-none' : 'text-[4vh]' } font-bold ${isWarning && !isLiveView ? warningColors.textColor : isLiveView ? 'text-white' : 'text-black'} relative z-10`}>
        {fouls}
      </span>
    </div>
    {!isLiveView && (
    <button
      onClick={() => onFoulChange(fouls + 1)}
      className="w-[8vh] h-[8vh] bg-amber-500 text-black text-[4vh] font-bold rounded-lg hover:bg-amber-600"
    >
      +
    </button>
    )}
  </div>
  );
};

export default TeamFoulsCounter;